class AdminApiFetcher {
    constructor() {
      this.url = 'https://koparkoladowarka-99ee7a3b3d34.herokuapp.com';
    }
  
    reloadPage() {
      localStorage.removeItem('adminJwt');
      window.location.href = window.location.href;
    }
  
    sessionExpired() {
      alert('Sesja wygasła!');
      this.reloadPage();
    }
  
    getToken() {
      return localStorage.getItem('adminJwt');
    }
  
    async getEventId(userId) {
      try {
        const token = this.getToken();
        if (!token) return false;
        const response = await fetch(`${this.url}/api/get-eventId?userId=${userId}`, {
          method: 'get',
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-type": `application/json`
          },
        });
        const { event } = await response.json();
        if(event.length === 0) return false;
        return event[0].id;
        
      } catch (error) {
        throw error;
      }
    }
  

    async deletePoinst(userId, points) {
      try {
        const token = this.getToken();
        if(!token) return false;

        const response = await fetch(`${this.url}/api/delete-points`, {
          method: `delete`,
          headers:{
            "Authorization": `Bearer ${token}`,
            "Content-type": `application/json`
          },
          body: JSON.stringify({userId: userId, points: points })
        })
        if(!response) return false;
        const {success} = await response.json();
        if(!success) return false

        return success
      }catch(error) {
        throw error
      }
    }

    async getAllEvents(type, currentDate) {
      try {

        const token = this.getToken();
        if(!token) return;

        const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(),1)
        const endOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0)
        const today = new Date()
        const isCurrentMonth = today.getMonth() === currentDate.getMonth() && today.getFullYear() === currentDate.getFullYear()

        let timeMin;
        let timeMax
        if(type === `active`) {

          if(isCurrentMonth) {
            timeMax = endOfMonth
            timeMin = today

          }else {
            timeMin = startOfMonth
            timeMax = endOfMonth
          }
        }else if(type === `archive`) {
          if(isCurrentMonth) {
            timeMin = startOfMonth
            timeMax = today
          }else {
            timeMin = startOfMonth
            timeMax = endOfMonth
          }
        }

        const events = await fetch(`${this.url}/api/get-all-events?timeMin=${timeMin}&timeMax=${timeMax}`, {
          method: 'get',
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-type": `application/json`
          },
        });
        return await events.json();
      } catch (error) {
        console.log(error);
        this.sessionExpired();
      }
    }
  
    async getUnrealizedEvents(currentDate) {
      try {
        const token = this.getToken();
        if (!token)  return
        let timeMin = new Date(currentDate.getFullYear(), currentDate.getMonth(),1);
        let timeMax = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        const events = await fetch(`${this.url}/api/get-unrealized-events?timeMin=${timeMin}&timeMax=${timeMax}`, {
          method: 'GET',
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        });
        const data = await events.json();
        return data;
      } catch (error) {
        console.log(error);
        this.sessionExpired();
      }
    }
  
    async getAdmins(page) {
      try {
        const token = this.getToken();
        if (token) {
          const response = await fetch(`${this.url}/api/admin-get-admins?page=${page}}`, {
            method: 'get',
            headers: {
              "Authorization": `Bearer ${token}`,
              "Content-type": `application/json`
            }
          });
          const data = await response.json();
          return data;
        }
      } catch (error) {
        throw error
      }
    }
  
    async removeAdmin(userId) {
      try {
        const token = this.getToken();
        const body = JSON.stringify({ userId });
        if (token) {
          const response = await fetch(`${this.url}/api/remove-admin`, {
            method: 'post',
            headers: {
              "Authorization": `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
            body
          });
          const data = await response.json();
          return data;
        }
      } catch (error) {
        console.log(error);
      }
    }
  
    async authenticateToken() {
      try {
        const token = this.getToken();
        if (token) {
          const response = await fetch(`${this.url}/api/auth-token-admin`, {
            method: 'POST',
            headers: {
              "Authorization": `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
          });
          const data = await response.json();
          if (data) return data.confirmed;
        }
      } catch (error) {
        console.log(`Error: ${error}`);
      }
    }
  
    async addPoints(userId, points) {
      try {
        const token = this.getToken();
        if (token) {
          const response = await fetch(`${this.url}/api/add-points`, {
            method: 'POST',
            headers: {
              "Authorization": `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ userId, points })
          });
          const data = await response.json();
          return data;
        } else {
          this.sessionExpired();
        }
      } catch (error) {
        this.sessionExpired();
        console.log(error);
      }
    }
  
    async markAs(mark, eventId) {
      try {
        const token = this.getToken();
        if (token) {
          console.log(mark)
          const response = await fetch(`${this.url}/api/mark-as`, {
            method: 'POST',
            headers: {
              "Authorization": `Bearer ${token}`,
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ eventId, markAs: mark })
          });
          if (!response) return;
          return await response.json();
        }
      } catch (error) {
        console.log(error);
        this.sessionExpired();
      }
    }
  
    async createAdmin(userData) {
      try {
        const token = this.getToken();
        if (token) {
          const response = await fetch(`${this.url}/api/create-admin`, {
            method: 'POST',
            headers: {
              "Authorization": `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ userData })
          });
          const data = await response.json();
          return data;
        }
      } catch (error) {
        this.sessionExpired();
        throw error
      }
    }
  
    async createUser(userData) {
      try {
        const token = this.getToken();
        if (token) {
          const response = await fetch(`${this.url}/api/admin-create-user`, {
            method: 'POST',
            headers: { 
              "Authorization": `Bearer ${token}`,
              "Content-Type": "application/json"
             },
            body: JSON.stringify(userData),
          });
          const data = await response.json();
       
          return data;
        }
      } catch (error) {
        throw error
        // this.sessionExpired();
      }
    }
  
    async sendUserData(userData) {
      try {
        const response = await fetch(`${this.url}/api/admin-login`, {
          method: 'POST',
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(userData)
        });
        const data = await response.json();
        if (!data.response.confirmed && !data.response.token) {
          return alert(`Nieprawidłowy login lub hasło!`)
        }
        const token = data.response.token;
        localStorage.setItem('adminJwt', token);
        return true;
      } catch (err) {
        throw err
      }
    }
  
    async getAllUsers(page) {
      try {
        const token = this.getToken();
        if (!token) {
          this.sessionExpired();
          return;
        }
        const response = await fetch(`${this.url}/api/admin-get-users?page=${page}`, {
          method: 'GET',
          headers: {
            "Authorization": `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const data = await response.json();
        if(!data) return;
        return data;
      } catch (error) {
        this.sessionExpired();
        throw error
      }
    }
  
    async getAwaitingUsers() {
      try {
        const token = this.getToken();
        if (token) {
          const response = await fetch(`${this.url}/api/get-waiting-users`, {
            method: 'POST',
            headers: {
              "Authorization": `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
          });
          const data = await response.json();
          return data;
        } else {
          return false;
        }
      } catch (error) {
        this.sessionExpired();
        throw error
      }
    }
  }
  
  export default AdminApiFetcher;